import React from 'react'
import {Lang} from 'yougile-lang'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {getValueByKey} from '@components/common/base/select-with-dropdown/utils'
import {TwSetting} from '@components/sticker/my-stickers/board-stickers/sticker-settings/containers'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {useCommonHandlers} from '@components/sticker/my-stickers/board-stickers/sticker-settings/use-common-handlers'

interface CommonStateSettingsContentProps extends CommonProps {
  options: OptionsItem[]
  placeholder: string
}

export const CommonStateSettingsContent = (
  props: CommonStateSettingsContentProps
) => {
  const {state, sticker, setState, placeholder, options} = props
  const {toggleHasDefaultState, onDefaultStateChanged} = useCommonHandlers(
    sticker,
    setState
  )
  const defaultState = state.defaultState as string
  const value =
    defaultState === 'no-default-state'
      ? placeholder
      : getValueByKey(options, defaultState)

  return (
    <TwSetting>
      <CheckboxNew
        className="py-8"
        value={state.hasDefaultState ?? false}
        onChange={toggleHasDefaultState}
        label={Lang.msg.myStickers.setDefaultValue}
      />
      <SelectWithDropdown
        disabled={!state.hasDefaultState}
        className="ml-24 !w-[380px]"
        options={options}
        onChange={x => onDefaultStateChanged(x.key)}
        placeholder={placeholder}
        value={value}
        variant="new"
      />
    </TwSetting>
  )
}
